import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { getProductAction } from '@finect/front-resources/Products';
import { Icon } from '../../../Icon';
import { AggregatedBadge, AggregatedBadgeText } from '../FeaturedProductDistributor/partials';
import { CardInfo, CardColumns, OrganizationName, CardMainContent, ActionLink } from './partials';
export var ProductDistributor = function ProductDistributor(_ref) {
  var product = _ref.product,
    commercialization = _ref.commercialization,
    onAction = _ref.onAction,
    _ref$userBank = _ref.userBank,
    userBank = _ref$userBank === void 0 ? null : _ref$userBank,
    userBankState = _ref.userBankState,
    banks = _ref.banks,
    _ref$isPartner = _ref.isPartner,
    isPartner = _ref$isPartner === void 0 ? false : _ref$isPartner;
  var organization = commercialization.organization;
  var organizationHasBlog = organization && organization.features && organization.features.blog;
  var url = organizationHasBlog ? "".concat(isPartner ? getSuperPartnerBaseURL() : '').concat(organization.web) : null;
  var iconURL = organization.icon ? "https://www.finect.com/image/".concat(organization.icon) : null;
  var fetched = userBankState.fetched,
    fetching = userBankState.fetching;
  var bankAggregate = banks.find(function (bank) {
    return bank.organization && bank.organization.id === commercialization.organization.id;
  });
  return React.createElement(CardInfo, {
    isAggregated: Boolean(userBank)
  }, React.createElement(AggregatedBadge, null, fetched && !fetching && userBank ? React.createElement(AggregatedBadgeText, null, 'Enlazado') : bankAggregate ? React.createElement(AppLink, {
    href: "https://www.finect.com/tus-inversiones/bancos/agregar"
  }, "Enlazar") : null), React.createElement(CardColumns, null, React.createElement(Icon, {
    type: organization.subtype,
    size: 2,
    alt: organization.displayName,
    image: iconURL,
    margin: "0 8px 0 0",
    aditionalIcon: null,
    withBorder: true,
    url: url
  }), React.createElement(CardMainContent, null, React.createElement(OrganizationName, {
    href: url
  }, organization.displayName), React.createElement(ActionLink, {
    onClick: onAction,
    rel: "nofollow"
  }, userBank ? getProductAction(product).action : 'Abrir cuenta', React.createElement(ArrowRight, {
    size: 16
  })))));
};